import styles from "../../../styles/Components/mini-app/auth/MiniAppLoginPage.module.css";
import { Button, Form, Input } from "antd";
import React, { useEffect, useState } from "react";
import poolData from "../../../pages/Auth/AWSConfig/PoolData";
import { saveUserPass } from "../../../redux/main/action/main";
import { notify } from "../../../utility/Toastify/toastify";
import { useSearchParams } from "react-router-dom";
import ReferralModal from "../../auth/ReferralModal";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { miniAppSignUpValidation } from "../../../utility/Validation/validation";
import { useDispatch } from "react-redux";
import { handleBlur } from "../../../utility/action";
import { TfiEmail } from "react-icons/tfi";
import { HiOutlineLockClosed } from "react-icons/hi";
import { FaUser } from "react-icons/fa6";
import { BsEnvelopePaperHeart } from "react-icons/bs";
import RecaptchaModal from "../../../pages/Auth/login/RecaptchaModal";

function MiniAppSignupPage({ setAuthType }) {
  const [loading, setLoading] = useState(false);
  const [checkCount, setCheckCount] = useState(0);
  const [showReferralModal, setShowReferralModal] = useState(false);
  const [submitData, setSubmitData] = useState({});
  const [showRecaptchaModal, setShowRecaptchaModal] = useState(false);
  const [params] = useSearchParams();
  const dispatch = useDispatch();

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: yupResolver(miniAppSignUpValidation),
    mode: "onBlur",
  });

  // Get the value of the 'telegram_auth' parameter
  const telegramAuth = params.get("tgWebAppStartParam");

  const referralCode = params.get("referal_code");

  const [referralValue, setReferralValue] = useState(referralCode || "");

  const onSubmit = (data) => {
    // if (!referralCode && checkCount === 0) {
    //   setSubmitData(data);
    //   setShowReferralModal(true);
    //   setCheckCount(1);
    //   return;
    // }
    setReferralValue(String(data.referralValue || "").trim());
    setShowRecaptchaModal(true);
    setSubmitData(data);
    setLoading(true);

    // poolData.signUp(
    //   data?.email.toLowerCase(),
    //   data?.pass,
    //   [
    //     { Name: "email", Value: data?.email.toLowerCase() },
    //     {
    //       Name: "custom:custom_username",
    //       Value: data?.username,
    //     },
    //     { Name: "custom:about_us", Value: "" },
    //     {
    //       Name: "custom:referal_code",
    //       Value:
    //         data?.referralValue?.length < 10
    //           ? "          "
    //           : data?.referralValue,
    //     },
    //   ],
    //   [],
    //   (err, res) => {
    //     if (res) {
    //       // emailHandler(res.user.username.toLowerCase());
    //       dispatch(saveUserPass([data?.email.toLowerCase(), data?.pass]));
    //       localStorage.setItem("userPass", [
    //         data?.email.toLowerCase(),
    //         data?.pass,
    //       ]);
    //       setAuthType("confirm");
    //       setLoading(false);
    //     }
    //     if (err) {
    //       notify(err?.message, "error");
    //       setLoading(false);
    //     }
    //   },
    //   null,
    // );
    // setCheckCount(0);
  };

  useEffect(() => {
    if (referralCode) {
      setValue("referralValue", referralCode);
    }
  }, [referralCode, setValue]);

  return (
    <>
      <h4 className={styles.title}>
        <span>Create</span> <br />
        Your Account
      </h4>
      <Form onFinish={handleSubmit(onSubmit)}>
        <Form.Item
          label=""
          validateStatus={errors.username ? "error" : ""}
          help={errors.username ? errors.username.message : ""}
          className={styles.formItem}
        >
          <Controller
            name="username"
            control={control}
            render={({ field }) => (
              <div className={styles.inputWrapper}>
                <FaUser color="#454545" />
                <Input
                  {...field}
                  placeholder="Username"
                  type="username"
                  onBlur={(e) => {
                    field.onBlur(e);
                    handleBlur(e);
                  }}
                />
              </div>
            )}
          />
        </Form.Item>
        <Form.Item
          label=""
          validateStatus={errors.email ? "error" : ""}
          help={errors.email ? errors.email.message : ""}
          className={styles.formItem}
        >
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <div className={styles.inputWrapper}>
                <TfiEmail color="#454545" />
                <Input
                  {...field}
                  placeholder="Email"
                  type="email"
                  onBlur={(e) => {
                    field.onBlur(e);
                    handleBlur(e);
                  }}
                />
              </div>
            )}
          />
        </Form.Item>

        <Form.Item
          validateStatus={errors.pass ? "error" : ""}
          help={errors.pass ? errors.pass.message : ""}
          className={styles.formItem}
        >
          <Controller
            name="pass"
            control={control}
            render={({ field }) => (
              <div className={styles.inputWrapper}>
                <HiOutlineLockClosed color="#454545" />
                <Input
                  {...field}
                  type="password"
                  onBlur={(e) => {
                    field.onBlur(e);
                    handleBlur(e);
                  }}
                  placeholder="Password"
                  autoComplete="new-password"
                />
              </div>
            )}
          />
        </Form.Item>

        <Form.Item
          validateStatus={errors.confirmPass ? "error" : ""}
          help={errors.confirmPass ? errors.confirmPass.message : ""}
          className={styles.formItem}
        >
          <Controller
            name="confirmPass"
            control={control}
            render={({ field }) => (
              <div className={styles.inputWrapper}>
                <HiOutlineLockClosed color="#454545" />
                <Input
                  {...field}
                  type="password"
                  onBlur={(e) => {
                    field.onBlur(e);
                    handleBlur(e);
                  }}
                  placeholder="Confirm Password"
                  autoComplete="new-password"
                />
              </div>
            )}
          />
        </Form.Item>

        <Form.Item
          label=""
          validateStatus={errors.referralValue ? "error" : ""}
          help={errors.referralValue ? errors.referralValue.message : ""}
          className={styles.formItem}
        >
          <Controller
            name="referralValue"
            control={control}
            render={({ field }) => (
              <div className={styles.inputWrapper}>
                <BsEnvelopePaperHeart color="#454545" />
                <Input
                  {...field}
                  placeholder="Referral Code (Optional)"
                  disabled={!!referralCode}
                  onChange={(e) => {
                    field.onChange(e);
                    setReferralValue(e.target.value.trim());
                  }}
                  onBlur={(e) => {
                    field.onBlur(e);
                    handleBlur(e);
                  }}
                />
              </div>
            )}
          />
        </Form.Item>

        <Form.Item style={{ alignSelf: "center", width: "100%" }}>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            className={styles.submitBtn}
          >
            Sign Up
          </Button>
        </Form.Item>

        {/*<p*/}
        {/*    className={styles.switchToLoginBtn}*/}
        {/*    onClick={() => setAuthType("login")}*/}
        {/*>*/}
        {/*    Already have an account? <span>Login</span>*/}
        {/*</p>*/}

        <ReferralModal
          data={submitData}
          setReferral={setReferralValue}
          setShow={setShowReferralModal}
          show={showReferralModal}
          submit={onSubmit}
        />
      </Form>

      <div className={styles.signupOption} onClick={() => setAuthType("login")}>
        Already have an account? <span>Login</span>
      </div>

      {showRecaptchaModal && (
        <RecaptchaModal
          data={submitData}
          useCase="signup"
          open={showRecaptchaModal}
          isMiniApp={true}
          referralCode={referralValue}
          onClose={() => {
            setShowRecaptchaModal(false);
            setLoading(false);
          }}
        />
      )}
    </>
  );
}

export default MiniAppSignupPage;
